define( function() {
	return [];
} );



// WEBPACK FOOTER //
// ./~/jquery/src/var/deletedIds.js